import React from 'react';
import { Modal } from 'antd';
import './DemoModal.css';

/** A coded demo shown large in a dialog; it mounts on open and stops when the dialog closes. */
const DemoModal = ({ open, onClose, children }) => (
    <Modal
        open={open}
        onCancel={onClose}
        footer={null}
        width="min(1100px, 92vw)"
        centered
        destroyOnHidden
        rootClassName="tendera-demo-modal"
        styles={{ body: { padding: 0 } }}
    >
        {children}
    </Modal>
);

export default DemoModal;
